/**
 * Shared layer state for global overlays.
 *
 * Each controller owns its own visual + ARIA state, but scroll locking is
 * shared so one layer closing cannot unlock the page while another is open.
 * Controllers can also ask another layer to close by dispatching a named event,
 * which keeps close logic in the owning controller.
 */
(function () {
  if (window.BaldiLayers) return;

  var html = document.documentElement;
  var locks = {};

  function hasLocks() {
    for (var key in locks) {
      if (Object.prototype.hasOwnProperty.call(locks, key)) return true;
    }
    return false;
  }

  function syncScrollLock() {
    html.style.overflow = hasLocks() ? 'hidden' : '';
  }

  window.BaldiLayers = {
    lock: function (key) {
      if (!key) return;
      locks[key] = true;
      syncScrollLock();
    },
    unlock: function (key) {
      if (!key) return;
      delete locks[key];
      syncScrollLock();
    },
    close: function (layer) {
      var event;
      if (!layer) return;
      if (typeof CustomEvent === 'function') {
        event = new CustomEvent('baldi:' + layer + ':close');
      } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('baldi:' + layer + ':close', false, false, null);
      }
      document.dispatchEvent(event);
    }
  };
})();
